import assetPath from '/opt/actions-runner/_work/crate/crate/brewery-packages/xds/xing-logo/src/assets/xing-favicon.ico';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')